// Module
var code = "<div class=row> <div class=col-xs-12> <table name=genericParametersTable nlg-table=genericParametersTableOptions> <thead> <tr nlg-table-headers nlg-table-dynamic-sort> </tr> </thead> <tbody> <tr ng-repeat=\"record in genericParametersTableOptions.records\" nlg-table-rows name={{$index}}> </tr> </tbody> </table> </div> </div>";
// Exports
module.exports = code;